export const mockOfferCodeKeyword = "KEYWORD";
export const mockCategoriesKeyword = "CATEGORIES";
